// extracted by mini-css-extract-plugin
module.exports = {"change":"ImageUploader_change__1EHBX","spinner":"ImageUploader_spinner__2g2rL"};